import { FleekError } from './FleekError';

type GitConfigFailedToParseErrorOptions = Record<string, never>;

export class GitConfigFailedToParseError extends FleekError<GitConfigFailedToParseErrorOptions> {
  public name = 'GitSecretsFailedToEncryptError';

  toString = () => 'Failed to parse Git Configs.';
}
